/* eslint no-console: 0 */

import fr from './fr.json'
import en from './en.json'

type Json = string | { [key: string]: Json }

const flatKeys = (start: Json, root: string) => {
  if (typeof start === 'string') {
    return [root]
  }

  const keys = Object.keys(start)

  return keys.reduce((acc, cur) => {
    const item = start[cur]
    acc.push(...flatKeys(item, `${root ? root + '.' : ''}${cur}`))

    return acc
  }, [] as string[])
}

const test = () => {
  console.log('Running test on traduction keys')

  const frKeys = flatKeys(fr, '')
  const enKeys = flatKeys(en, '')

  const missingEn = frKeys.filter((k) => !enKeys.includes(k))
  const missingFr = enKeys.filter((k) => !frKeys.includes(k))

  if (missingEn.length > 0) {
    console.error('missing keys in en : ', missingEn.join('|'))
  }

  if (missingFr.length > 0) {
    console.error('missing keys in fr : ', missingFr.join('|'))
  }
}

export default test
